import { render } from "./App.vue?vue&type=template&id=45591c6c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/usuario/Documents/R/cursos/fstck/mevn-01/mevn-typescript/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__